// extracted by mini-css-extract-plugin
module.exports = {"legend_fixed_container":"LegendFixed_legend_fixed_container__Ccbc1","close_btn":"LegendFixed_close_btn__2dKSg","close_legend_container":"LegendFixed_close_legend_container__35pQJ"};